import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent';

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

const toneStyles: Record<BadgeTone, string> = {
  neutral: 'bg-(--bg-surface-strong) text-(--text-secondary) border border-(--border-default)',
  success: 'bg-(--accent-success)/15 text-(--accent-success) border border-(--accent-success)/30',
  warning: 'bg-(--accent-warning)/15 text-(--accent-warning) border border-(--accent-warning)/30',
  danger: 'bg-(--accent-danger)/15 text-(--accent-danger) border border-(--accent-danger)/30',
  info: 'bg-(--accent-info)/15 text-(--accent-info) border border-(--accent-info)/30',
  accent: 'bg-(--accent-primary)/15 text-(--accent-primary) border border-(--accent-primary)/30',
};

export default function Badge({ tone = 'neutral', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium tracking-wide',
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
